import { ModalHeader } from '@/components/Modal'
import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'
import { useController } from '../hooks/useController'
import { useTexts } from '../useTexts'

export function Header() {
  const texts = useTexts()
  const {
    data: { driverAssignmentIds },
    close,
  } = useController()

  const title = texts.title(driverAssignmentIds.length)

  return (
    <ModalHeader
      title={title}
      actions={[
        <ActionBarItem
          icon={<Close />}
          testId="close-button"
          key="close"
          onClick={close}
          label=""
        />,
      ]}
    />
  )
}
